var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "app" } },
    [
      _c("div", { attrs: { id: "modal" } }),
      _vm._v(" "),
      _c("div", { attrs: { id: "add-user-modal" } }),
      _vm._v(" "),
      _c("div", { attrs: { id: "preview-modal" } }),
      _vm._v(" "),
      _c("div", { attrs: { id: "mail-modal" } }),
      _vm._v(" "),
      _c("div", { attrs: { id: "save-modal" } }),
      _vm._v(" "),
      _c("div", { attrs: { id: "camera-position-modal" } }),
      _vm._v(" "),
      _c("router-view")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c76552b2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c76552b2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/main/js/AppDc.vue
// module id = null
// module chunks = 